import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import helpEn from '../locales/help/en.json';
import helpAr from '../locales/help/ar.json';

export const HELP_I18N_STORAGE_KEY = 'admin_help_language';

export type HelpLanguage = 'en' | 'ar';

export const helpI18n = i18n.createInstance();

if (!localStorage.getItem(HELP_I18N_STORAGE_KEY)) {
  localStorage.setItem(HELP_I18N_STORAGE_KEY, 'en');
}

helpI18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: helpEn },
      ar: { translation: helpAr },
    },
    lng: localStorage.getItem(HELP_I18N_STORAGE_KEY) || 'en',
    fallbackLng: 'en',
    supportedLngs: ['en', 'ar'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: HELP_I18N_STORAGE_KEY,
      caches: ['localStorage'],
    },
  });

export const setHelpLanguage = (lng: HelpLanguage) => {
  localStorage.setItem(HELP_I18N_STORAGE_KEY, lng);
  void helpI18n.changeLanguage(lng);
};

export const toggleHelpLanguage = () => {
  const next: HelpLanguage = helpI18n.language.startsWith('ar') ? 'en' : 'ar';
  setHelpLanguage(next);
};

export const isHelpArabic = (language = helpI18n.language): boolean =>
  language.startsWith('ar');
